export default "__VITE_ASSET__BNIyNOIf__"